<script lang="ts">
	import domain from '$lib/stores/DomainStore';
	import Burger from './Burger.svelte';
	import __ from '$lib/stores/TranslationStore';
	import Menu from './Menu.svelte';
	import Cta from '../Cta.svelte';
	import Search from '$lib/components/Blog/Search.svelte';
	import SearchIcon from '$lib/assets/images/icons/search.svg?component';
	import { slide } from 'svelte/transition';
	import { isUrlBlog } from '$lib/utils/helpers/isUrlBlog';
	import { page } from '$app/stores';
	let showMenu: boolean | any;

	let showSearch = false;
	let fromBlog = isUrlBlog($page.url);
</script>

<nav
	data-sveltekit-preload-data="off"
	data-sveltekit-reload
	class:lg:pb-0={fromBlog && showSearch}
	class:pb-0={fromBlog && showSearch}
	class="sticky top-0 z-20 flex w-full flex-col items-center divide-y-2 leading-nav lg:py-[10px] {$domain?.headerBackground} {$domain?.headerColor}"
>
	<div
		class="flex h-[60px] w-full min-w-fit items-center justify-between px-4 text-sm 2xl:container lg:mx-auto lg:flex-nowrap lg:gap-x-5"
	>
		<a href={$page.data?.location?.origin} class="flex items-center md:shrink-0">
			<img
				src={$domain?.logo}
				class="h-5 w-full max-w-[70vw] md:h-4 xl:h-6"
				alt="Poupança no minuto"
			/>
		</a>
		<!-- Menu desktop -->
		<div class="hidden lg:block lg:grow" id="navbar-dropdown">
			<Menu showMenu={true} />
		</div>
		<div class:lg:hidden={!fromBlog} class="flex justify-end gap-x-2 sm:gap-x-4 lg:justify-end">
			{#if fromBlog}
				<button
					class:hidden={showMenu}
					title={$__('Pesquisar artigos')}
					on:click={() => (showSearch = !showSearch)}
					class:bg-light={showSearch}
					class="flex h-10 w-10 items-center justify-center rounded-full hover:bg-light"
				>
					<SearchIcon class="h-7 w-7 stroke-dark stroke-2 transition hover:scale-110" />
				</button>
			{/if}
			<button
				data-collapse-toggle="navbar-dropdown"
				type="button"
				class:hidden={showSearch}
				class="inline-flex items-center justify-end p-2 text-sm text-gray-500 lg:hidden"
				aria-controls="navbar-dropdown"
				aria-expanded="false"
				on:click={() => (showMenu = !showMenu)}
			>
				<span class="sr-only">Open main menu</span>
				<Burger {showMenu} />
			</button>
		</div>
		<Cta
			type="anchor"
			class="hidden text-xl/none leading-nav-button lg:flex lg:px-3 lg:text-base/none xl:px-7 xl:text-xl/none 3xl:text-nav-button {$domain?.buttonBackground} {$domain?.buttonColor}"
			props={{
				'data-sveltekit-preload-data': 'off',
				href: '/simuladores'
			}}
			on:click
		>
			{$__('Simular crédito')}
		</Cta>
	</div>
	<!-- Menu mobile -->
	<div class:hidden={!showMenu} class="w-full lg:hidden" id="navbar-dropdown">
		<Menu {showMenu} on:click={() => (showMenu = false)} />
	</div>
	{#if fromBlog && showSearch}
		<div class="mt-[10px] w-full" transition:slide={{ duration: 100 }}>
			<Search />
		</div>
	{/if}
</nav>
